// React
import React from "react";
//-------------------------------------------------------------------------------------------------------------------------------
//-- Styles
//-------------------------------------------------------------------------------------------------------------------------------
import styles from "./List.less";
//-------------------------------------------------------------------------------------------------------------------------------
//-- Component
//-------------------------------------------------------------------------------------------------------------------------------
export default class List extends React.Component {
    render() {
        return (React.createElement("div", null, React.Children.map(this.props.children, (child) => React.createElement("div", { className: styles.item }, child))));
    }
}
